import { Snackbar, TextField } from '@material-ui/core'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import LaunchIcon from '@mui/icons-material/Launch'
import ButtonShadow from 'components/ButtonShadow/ButtonShadow'
import React, { useCallback, useRef, useState } from 'react'
import * as Styled from './LinkWrapper.styled'
import openURL from 'utils/openURL'

interface LinkWrapperProps {
  url: string
  /** @default true */
  canOpenLink?: boolean
}

const LinkWrapper: React.FC<LinkWrapperProps> = ({
  url,
  canOpenLink = true,
}) => {
  const [copyTextResult, setCopyTextResult] = useState<string | undefined>(
    undefined,
  )
  const inputUrlRef = useRef<HTMLInputElement>(null)

  const handleCopyLink = useCallback(async () => {
    inputUrlRef.current?.select()
    const success = document.execCommand('copy')
    setCopyTextResult(success ? 'Link Copiado!' : 'Erro ao copiar link')
    inputUrlRef.current?.blur()
  }, [])

  const handleOpenLink = useCallback(async () => {
    await openURL(url)
  }, [url])

  return (
    <Styled.Container>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!copyTextResult}
        onClose={() => setCopyTextResult(undefined)}
        message={copyTextResult}
        autoHideDuration={3000}
      />

      <TextField
        type="text"
        value={url}
        onChange={() => {}}
        variant="outlined"
        fullWidth
        inputRef={inputUrlRef}
      />

      <Styled.ActionsContainer>
        <ButtonShadow
          leftIcon={<ContentCopyIcon style={{ color: 'white' }} />}
          onPress={handleCopyLink}
        />
        {canOpenLink && (
          <ButtonShadow
            leftIcon={<LaunchIcon style={{ color: 'white' }} />}
            onPress={handleOpenLink}
          />
        )}
      </Styled.ActionsContainer>
    </Styled.Container>
  )
}

export default LinkWrapper
